<template>
    <v-container class="inputContainer">
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-overlay :value="sending" z-index="10000">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <span class="loading">処理中です...</span>
        </v-overlay>
        
        <v-dialog
            v-model="templateInputDialog"
            width="60%"
        >
            <agreement-input-select-template-component :maxPages="maxPages" :pdfWidth="pdfWidth" :inputs="inputs" :currentUid="agreementObjId" :currentPdfId="currentPdfId" :templateItems="templateItems" 
            @templateInputSave="templateInputSave" @templateInput="templateInput">
            </agreement-input-select-template-component>
        </v-dialog>

        <add-input-component :templateInputShow="templateInputShow" @addText="addText" @addSelect="addSelect" @addCheckbox="addCheckbox" @addSeal="addSeal" @templateInput="templateInput" />
        <v-row justify="center">
            <v-card color="grey lighten-3">
                <v-tabs
                    v-model="fileTab"
                    dark
                    background-color="grey"
                    show-arrows
                >
                    <v-tabs-slider></v-tabs-slider>
    
                    <v-tab
                        v-for="(pdfObj, index) in Object.entries(this.pdfs)"
                        :key="`tab-${index}`"
                        :disabled="pdfLoading"
                        v-on:click="changePdf(pdfObj[0])"
                    >
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <span
                                class="info-to file_name"
                                v-bind="attrs"
                                v-on="on"
                                >
                                    {{ pdfObj[1].filename | omittedText }}
                                </span>
                            </template>
                            <span>{{ pdfObj[1].filename }}</span>
                        </v-tooltip>
                        
                    </v-tab>
                </v-tabs>
                <pdf-document-component
                    v-for="(pdfObj, index) in Object.entries(this.pdfs)"
                    :key="`pdf-${currentPdfId}-${index}${timer}`"
                    v-show="currentPdfId==pdfObj[0]"
                    scale="1"
                    :url="baseUrl+pdfObj[0]"
                    :pdfId="pdfObj[0]"
                    :destinations="destinations"
                    :colorsIdMap="colorsIdMap"
                    :bgColorsIdMap="bgColorsIdMap"
                    :createUserId="createUserId"
                    :addInputs="inputs[pdfObj[0]]"
                    :maxObjId="maxObjectId"
                    ref="document"
                    @loading="loading"
                    @updateInput="updateInput"
                    @updateMaxPages="updateMaxPages"
                    @updatePdfWidth="updatePdfWidth"
                    />
            </v-card>
            <v-card
                width="200px"
            >
                <v-card-title>
                    凡例
                </v-card-title>
                <destination-list-component
                    :destinations="destinations"
                    :colors="colors"
                    :bgcolors="bgcolors"
                >
                </destination-list-component>
            </v-card>
        </v-row>
        <v-row justify="center">
            <v-col
                cols="2"
            >
                <v-btn
                    block
                    color="red"
                    class="white--text"
                    v-on:click="next"
                >
                    次へ
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { colorList, bgColorList, colorListIdMap } from '../../common/colorUtil.js';
    export default {
        props: ['destinations', 'pdfs', 'createUserId', 'agreementObjId', 'registeredInputs', 'maxObjId', 'templateItems', 'isPaidPlan'],
        data: function () {
            return {
                fileTab: 0,
                inputNum: 0,
                currentPdfId: 0,
                pdfLoading: false,
                baseUrl: '',
                pdfIdMap: {},
                colors: [],
                bgcolors: [],
                colorsIdMap: {},
                bgColorsIdMap: {},
                message: {
                    success: false,
                    text: '',
                },
                sending: false,
                maxObjectId: 0,
                templateInputDialog:false,
                maxPages:"",
                pdfWidth: 0,
                templateInputShow: true,
                timer: "",
            };
        },
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
        filters: {
            omittedText(text) {
             // 11文字目以降は"…"
             return text.length > 10 ? text.slice(0, 10) + "…" : text;
            },
        },
        created: function () {
            this.currentPdfId = Object.entries(this.pdfs)[0][0];
            // pdfの取得URL
            this.baseUrl = '/documents/agreements/'+ this.agreementObjId + '/get-contract/';
            Object.entries(this.pdfs).forEach((val, i) => {
                this.pdfIdMap[val[0]] = i;
            });
            this.colors = colorList;
            this.bgcolors = bgColorList;
            let ids = [];
            this.destinations.forEach(val => {
                ids.push(val.id);
            });
            // 契約送付先IDと色のマッピング作成
            this.colorsIdMap = colorListIdMap(ids, colorList);
            this.bgColorsIdMap = colorListIdMap(ids, bgColorList);
            this.inputs = Object.assign({}, this.registeredInputs);
            this.maxObjectId = this.maxObjId;
            
            this.templateInputShow = this.isPaidPlan ? true : false;
        },
        methods: {
            changePdf: function (id) {
                this.currentPdfId = id;
            },
            loading: function (isLoading) {
                this.pdfLoading = isLoading;
            },
            saveInputs: async function (draft = null) {
                let result = false;
                // upload server
                var response = await axios.post(
                    '/documents/agreements/'+this.agreementObjId+'/save_input',
                    {
                        'inputs': this.inputs,
                        'create_user_id': this.createUserId,
                        'draft': draft,
                    }
                )
                .catch(function (response) {
                    console.log(response);
                    result = false;
                });
                result = response.data.success;
                if (response.data.message) {
                    this.message.text = response.data.message;
                    this.message.success = false;
                    // エラー対象のPDFを表示する
                    this.currentPdfId = response.data.fileId;
                    this.fileTab = Object.keys(this.pdfs).indexOf(response.data.fileId);
                    this.$refs.document[this.fileTab].currentPage = response.data.pageNum;
                }
                return result;
            },
            addText: function () {
                this.$refs.document[this.pdfIdMap[this.currentPdfId]].addText();
            },
            addSelect: function () {
                this.$refs.document[this.pdfIdMap[this.currentPdfId]].addSelect();
            },
            addCheckbox: function () {
                this.$refs.document[this.pdfIdMap[this.currentPdfId]].addCheckbox();
            },
            addSeal: function () {
                this.$refs.document[this.pdfIdMap[this.currentPdfId]].addSeal();
            },
            updateInput: function (pdfId, page, objectId, value) {
                this.maxObjectId = objectId;
                // すべての契約書の入力項目更新（最終的にサーバへ送信するデータ）
                if (!(pdfId in this.inputs)) {
                    this.inputs[pdfId] = new Object();
                }
                if (!(page in this.inputs[pdfId])) {
                    this.inputs[pdfId][page] = new Object();
                }
                this.inputs[pdfId][page][objectId] = value;
            },
            updateMaxPages: function (maxPages) {
                if(undefined != maxPages[this.currentPdfId])
                    this.maxPages = maxPages[this.currentPdfId]
            },
            updatePdfWidth: function (widths) {
                if(undefined != widths[this.currentPdfId])
                    this.pdfWidth = widths[this.currentPdfId]
            },
            next: async function() {
                this.sending = true;
                try {
                    let result = await this.saveInputs();
                    if (result) {
                        window.location = "confirm";
                    }
                }
                finally {
                    this.sending = false;
                }
            },
            // 保存
            save: async function(draft = null) {
                return await this.saveInputs(draft);
            },
            // テンプレートから入力項目をインポート
            templateInput: async function(isOpen) {
                this.templateInputDialog = isOpen 
            },
            templateInputSave: async function (uid,currentUid,currentPdfId,pdf,maxPages,pdfWidth) {
                let result = false;
                var self = this;
                this.sending = true;
                await window.axios
                    .post('template-input-import', {
                        'uid': uid,
                        'pdfId':pdf.id,
                        'currentUid':currentUid,
                        'currentPdfId':currentPdfId,
                        'maxPages':maxPages,
                        'pdfWidth':pdfWidth,
                    })
                    .then(function (response) {
                        if (response.data.success) {
                            self.message.success = true;
                            if(Object.keys(response.data.inputs).length > 0){
                                self.message.text = "インポート処理に成功しました";
                                self.currentPdfId = response.data.fileId;
                                self.fileTab = Object.keys(self.pdfs).indexOf(response.data.fileId);
                                self.$refs.document[self.fileTab].currentPage = response.data.pageNum;
                                self.$set(self.inputs,self.currentPdfId,response.data.inputs)
                                self.maxObjectId += response.data.count
                                self.timer = new Date().getTime()
                            }else{
                                self.message.text = "インポートするテンプレートに入力項目がありません";
                            }
                        } 
                        else {
                            if (response.data.message) {
                                self.message.text = response.data.message;
                            } else {
                                self.message.text = "インポート処理に失敗しました";
                            }
                            self.message.success = false;
                        }
                    })
                    .catch(function (response) {
                        self.message.text = "インポート処理に失敗しました";
                        self.message.success = false;
                    })
                    .finally(function () {
                        self.sending = false;
                    });
            },
        }
    };
</script>